// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"822":"fa587b93","947":"f1f0bfd5"}[chunkId] + ".chunk.css");